/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';

function RequirementsTagging({
  getRequirementList,
  requirementList,
  getPermitTypeList,
  permitTypeList,
  updateApplicationRequirements,
}) {
  const [requirementListFormat, setRequirementListFormat] = useState([]);
  const [permitTypeListFormat, setPermitTypeListFormat] = useState([]);
  const [mode, setMode] = useState(0);
  const [formData, setFormData] = useState([]);
  const updateData = () => {
    getRequirementList({ display_all: 1 });
    getPermitTypeList();
  };
  const formatFormData = () => {
    if (!_.isEmpty(permitTypeList)) {
      const list = permitTypeList.map((x) => ({
        id: x.id,
        type: _.get(x, 'attributes.name', ''),
        requirement_list: _.get(
          x,
          'included.applicationStatusRequirements',
          []
        ).map((item) => ({
          requirement_id: item.attributes.requirement_id,
          is_required: item.attributes.is_required,
        })),
      }));
      setPermitTypeListFormat(list);
      setFormData(list);
    }
  };

  const toggleIsRequired = (array, requirementId) =>
    array.map((item) =>
      item.requirement_id === requirementId
        ? { ...item, is_required: !item.is_required ? 1 : 0 }
        : item
    );

  const handleSetMode = (num) => {
    setMode(num);
  };

  const handleToggle = (type, permitId, reqId) => () => {
    handleSetMode(1);
    const item = formData.find((x) => +x.id === +permitId); // GET TARGET ROW

    let status;
    let payload;

    if (type === 'requirement_id') {
      status = item.requirement_list.filter(
        (x) => +x.requirement_id === +reqId
      );
      if (_.isEmpty(status)) {
        payload = _.concat(_.get(item, 'requirement_list', []), [
          { requirement_id: +reqId, is_required: 0 },
        ]);
      } else {
        payload = item.requirement_list.filter(
          (x) => +x.requirement_id !== +reqId
        );
      }
    }

    if (type === 'is_required') {
      status = item.requirement_list.filter(
        (x) => +x.requirement_id === +reqId && x.is_required === 1
      );
      payload = toggleIsRequired(item.requirement_list, +reqId);
    }

    const newItem = {
      // REFORMAT TARGET WITH NEW VALUE
      ...item,
      requirement_list: payload,
    };

    const reducedFormData = formData.filter((x) => +x.id !== +newItem.id); // REMOVE TARGET FROM FORMDATA
    const newFormData = _.concat(reducedFormData, newItem); // REBIULD FORMDATA
    setFormData(newFormData);
  };

  const renderCheckbox = (type, permitId, reqId) => {
    const item = formData.find((x) => +x.id === +permitId);
    const status = item.requirement_list.filter(
      (x) =>
        +x.requirement_id === +reqId &&
        (type !== 'is_required' || x.is_required === 1)
    );
    return (
      <button
        type="button"
        className="btn-blank"
        onClick={handleToggle(type, permitId, reqId)}
      >
        {_.isEmpty(status) ? (
          <i className="far fa-square icon-check-box" />
        ) : (
          <i className="fas fa-check-square icon-box" />
        )}
      </button>
    );
  };

  const handleSubmit = () => {
    handleSetMode(0);
    const args = formData.map((item) => ({
      application_status_id: item.id,
      requirements: item.requirement_list,
    }));
    // console.log("sArgs:", args)
    const filteredData = args.filter((item) => item.requirements.length > 0);

    const payload = {
      data: filteredData,
    };

    updateApplicationRequirements(payload);
  };

  const handleCancel = () => {
    setFormData(permitTypeListFormat);
    handleSetMode(0);
  };

  useEffect(() => {
    updateData();
  }, []);

  useEffect(() => {
    formatFormData();
  }, [permitTypeList]);

  useEffect(() => {
    if (!_.isEmpty(requirementList)) {
      const list = requirementList.map((x) => ({
        requirement_id: _.get(x, 'id', ''),
        requirement_name: _.get(x, 'attributes.name'),
      }));
      setRequirementListFormat(list);
    }
  }, [requirementList]);

  return (
    <div className="card p-0">
      <div className="card-content-listing">
        <div className="container-fluid p-0">
          <div className="row d-flex align-items-center">
            <div className="col-6">
              <h3>Requirements Tagging</h3>
            </div>
            <div className="col-6 d-flex">
              {mode === 1 ? (
                <React.Fragment>
                  <button
                    type="button"
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold ml-auto px-4 mr-1"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary btn-round font-weight-bold px-4"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </React.Fragment>
              ) : (
                ''
              )}
            </div>
          </div>
          {/* TABLE */}
          <div className="table-responsive mt-4">
            <table className="table table-borderless">
              <thead>
                <tr>
                  {!_.isEmpty(permitTypeListFormat) ? (
                    <React.Fragment>
                      <th scope="col" className="px-1">
                        Requirement Types
                      </th>
                      {permitTypeListFormat.map((item) => (
                        <React.Fragment key={item.id}>
                          <th scope="col" className="px-1">
                            <div className="w-100 text-center">
                              {item.type || ''}
                            </div>
                          </th>
                          <th scope="col" className="px-1 pr-3">
                            <div className="w-100 text-center">IS REQUIRED</div>
                          </th>
                        </React.Fragment>
                      ))}
                    </React.Fragment>
                  ) : (
                    <th scope="col">Requirement Types</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {!_.isEmpty(requirementListFormat) ? (
                  <React.Fragment>
                    {requirementListFormat.map((item) => (
                      <tr className="top-border" key={item.requirement_id}>
                        <td className="font-weight-bold py-3">
                          {item.requirement_name}
                        </td>
                        {permitTypeListFormat.map((x) => (
                          <React.Fragment key={x.id}>
                            <td className="py-3">
                              <div className="w-100 text-center">
                                {renderCheckbox(
                                  'requirement_id',
                                  x.id,
                                  item.requirement_id
                                )}
                              </div>
                            </td>
                            <td className="py-3 pr-3">
                              <div className="w-100 text-center">
                                {renderCheckbox(
                                  'is_required',
                                  x.id,
                                  item.requirement_id
                                )}
                              </div>
                            </td>
                          </React.Fragment>
                        ))}
                      </tr>
                    ))}
                  </React.Fragment>
                ) : (
                  <tr />
                )}
              </tbody>
            </table>
          </div>

          {/* <div className="row mt-3 mb-5">
            <div className="col">
              <div className="card d-flex align-content-center">
                <h4 className="mb-4 mt-3 text-center w-100">NEW</h4>
                {permitTypeListFormat.map(item => (
                  <div key={item.id} className="card mb-2">
                    <div className="container-fluid">
                      <div className="row">
                        <div className="col-11">
                          {item.label}
                        </div>
                        <div className="col-1">
                          <input type="checkbox" />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}

RequirementsTagging.propTypes = {
  getPermitTypeList: PropTypes.instanceOf(Function).isRequired,
  permitTypeList: PropTypes.instanceOf(Array).isRequired,

  getRequirementList: PropTypes.instanceOf(Function).isRequired,
  requirementList: PropTypes.instanceOf(Array).isRequired,

  updateApplicationRequirements: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  permitTypeList: _.get(api, `${c.GET_PERMIT_TYPE_LIST}.list`) || [],
  requirementList: _.get(api, `${c.GET_REQUIREMENT_LIST}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(RequirementsTagging);
